module.exports = __webpack_public_path__ + "static/media/Grand Square Cam 09-mobile.eb709eee.webp";